import { Link } from "react-router-dom";
import {
  chemsecSvgLarge,
  linkedInIcon,
  blueskyIcon,
  youtubeIcon,
} from "../../assets/icons";
import styles from "./footer.module.css";
import { useState } from "react";

export default function Footer() {
  const [currentYear] = useState(new Date().getFullYear()); // used for copyright year

  const handleCookieSettings = () => {
    // Check if Cookiebot is available and show the cookie settings dialog
    if (typeof (window as any).Cookiebot !== 'undefined') {
      (window as any).Cookiebot.show();
    } else {
      console.warn('Cookiebot is not available');
    }
  };

  return (
    <footer className={styles.footerContainer}>
      <div className={styles.footer}>
        <div className={styles.logo}>{chemsecSvgLarge}</div>
        <div className={styles.columnContainer}>
          <section className={styles.contact}>
            <h5 className={styles.contactHeader}>Contact</h5>
            <address>
              <p>Första Långgatan 18</p>
              <p>413 28 Göteborg, Sweden</p>
              <p>
                <a href="tel:+46 31 711 04 95">+46 31 711 04 95</a>
              </p>
              <p>
                <Link className={styles.column} to="mailto:info@chemsec.org">
                  info@chemsec.org
                </Link>
              </p>
            </address>
            <p>
              <Link to="https://chemsec.org/">www.chemsec.org</Link>
            </p>
          </section>
          <div className={styles.column}>
            <h5 className={styles.aboutHeader}>About Marketplace</h5>
            <ul>
              <li>
                <Link to="/safer-alternative">What is a safer alternative?</Link>
              </li>
              <li>
                <Link to="/terms-conditions">Terms and Conditions</Link>
              </li>
            </ul>
          </div>
          <div className={styles.column}>
            <h5 className={styles.forBuyersHeader}>For Buyers</h5>
            <ul>
              <li>
                <Link to="/search">Discover safer alternatives</Link>
              </li>
            </ul>
          </div>
          <div className={styles.column}>
            <h5 className={styles.forSuppliersHeader}>For Suppliers</h5>
            <ul>
              <li>
                <Link to="/advertise-your-alternative">Advertise your alternative</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className={styles.socialMedia}>
          <Link
            className={styles.linkedIn}
            to="https://www.linkedin.com/company/chemsec"
          >
            {linkedInIcon}
          </Link>
          <Link className={styles.bluesky} to="https://bsky.app/profile/chemsec.bsky.social">
            {blueskyIcon}
          </Link>
          <Link
            className={styles.youtube}
            to="https://www.youtube.com/channel/UC97v_GuqNrpAOrKgL3JmbOw"
          >
            {youtubeIcon}
          </Link>
        </div>
        <div className={styles.tail}>
          <p className={styles.copyRight}>
            ©{currentYear} The International Chemical Secretariat. All rights reserved.
          </p>
          <div className={styles.footerLinks}>
            <p>
              <button 
                onClick={handleCookieSettings}
                className={styles.cookieSettingsButton}
                type="button"
              >
                Cookie Settings
              </button>
            </p>
            <p>
              <Link to="/gdpr" preventScrollReset={true}>GDPR Policy</Link>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
